var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('v-avatar',[_c('img',{attrs:{"src":_vm.url,"alt":_vm.user.name}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }